import { BaseOptionModel } from '../models';

export const generateEnumOption = (enumObject: Object): BaseOptionModel[] => {
	if (!enumObject) {
		return [];
	}

	return Object.keys(enumObject).reduce((result, each) => {
		if (isNaN(Number(each))) {
			const inputOption = new BaseOptionModel();
			const label = each
				.replace(/([A-Z])/g, ' $1')
				.replace(/([0-9])/g, ' $1');

			inputOption.label = label;

			if (isNaN(Number(enumObject[each]))) {
				inputOption.value = enumObject[each];
			} else {
				inputOption.value = Number(enumObject[each]);
			}

			result.push(inputOption);
		}

		return result;
	}, []);
};
